// extracted by mini-css-extract-plugin
export default {"phone":"Phone_phone__YBtva","phoneDetailed":"Phone_phoneDetailed__HN-rQ Phone_phone__YBtva"};